import type { Theme } from "../ui/themes.ts"

export interface Tracking {
  registerPostcard(postcardId: string, flow: "Sender" | "Recipient"): void
  registerPage(page: string): void
  track<T extends EventName>(event: T, properties: EventProperties[T], callback?: () => void): void
}

export class LoggerTracking implements Tracking {
  registerPostcard(postcardId: string, flow: "Sender" | "Recipient") {
    console.log("registerPostcard", postcardId, flow)
  }

  registerPage(page: string) {
    console.log("registerPage", page)
  }

  track<T extends EventName>(event: T, properties: EventProperties[T], callback?: () => void) {
    console.log("track", event, properties, callback)
  }
}

export const EVENT_NAMES = {
  // Marketing
  SHOP_NOW_CLICKED: "Postcards: Shop Now Clicked",
  CHECKOUT_STARTED: "Postcards: Checkout Started",
  REQUEST_ORDER_CLICKED: "Postcards: Request An Order Clicked",

  // App
  GET_STARTED_CLICKED: "Postcards: Get Started Clicked",
  CONTINUE_CLICKED: "Postcards: Continue Clicked",
  VIEW_CLICKED: "Postcards: View Clicked",
  EDIT_CLICKED: "Postcards: Edit Clicked",
  BACK_CLICKED: "Postcards: Back Clicked",
  ADD_CLIP_CLICKED: "Postcards: Add Clip Clicked",
  ADD_MORE_CLICKED: "Postcards: Add More Clicked",
  DONE_CLICKED: "Postcards: Done Clicked",
  BUY_POSTCARD_CLICKED: "Postcards: Buy Postcard Clicked",
  REPLAY_CLICKED: "Postcards: Replay Clicked",
  DELETE_VIDEO: "Postcards: Delete Video",
  RE_ORDER_VIDEOS: "Postcards: Reorder Videos",
  OPEN_VIDEO_DIALOG: "Postcards: Open Video Dialog",
  CLOSE_VIDEO_DIALOG: "Postcards: Close Video Dialog",
  OPEN_SEAL_DIALOG: "Postcards: Open Seal Dialog",
  CLOSE_SEAL_DIALOG: "Postcards: Close Seal Dialog",
  PLAYLIST_ENDED: "Postcards: Playlist Ended",
  GET_NOTIFIED_FORM_SUBMITTED: "Postcards: Get Notified Form Submitted",
  EDIT_CARD_FORM_SUBMITTED: "Postcards: Edit Card Form Submitted",
  THEME_SELECTED: "Postcards: Theme Selected",
  SWIPE_COMPLETED: "Postcards: Swipe Completed",
  UPLOAD_STARTED: "Postcards: Upload Started",
  UPLOAD_CANCELLED: "Postcards: Upload Cancelled",
  UPLOAD_FAILED: "Postcards: Upload Failed",
  UPLOAD_SUCCEEDED: "Postcards: Upload Succeeded",
} as const

export type EventName = keyof typeof EVENT_NAMES

export const Events = Object.fromEntries(Object.keys(EVENT_NAMES).map((key) => [key, key])) as {
  [K in EventName]: K
}

export type EventProperties = {
  // Marketing
  SHOP_NOW_CLICKED: {}
  CHECKOUT_STARTED: {
    "Pack Variant": string
    Quantity: number
    "Total Price": number
  }
  REQUEST_ORDER_CLICKED: {}

  // App
  GET_STARTED_CLICKED: {}
  CONTINUE_CLICKED: {}
  VIEW_CLICKED: {}
  EDIT_CLICKED: {}
  BACK_CLICKED: {}
  ADD_CLIP_CLICKED: {}
  ADD_MORE_CLICKED: {}
  DONE_CLICKED: {}
  BUY_POSTCARD_CLICKED: {}
  REPLAY_CLICKED: {}
  DELETE_VIDEO: { "Video ID": string }
  RE_ORDER_VIDEOS: { "Video IDs": string }
  OPEN_VIDEO_DIALOG: {}
  CLOSE_VIDEO_DIALOG: {}
  OPEN_SEAL_DIALOG: {}
  CLOSE_SEAL_DIALOG: {}
  PLAYLIST_ENDED: {}
  GET_NOTIFIED_FORM_SUBMITTED: {}
  EDIT_CARD_FORM_SUBMITTED: {}
  THEME_SELECTED: {
    Theme: Theme
  }
  SWIPE_COMPLETED: {
    Action: "Seal" | "Say Thanks"
  }
  UPLOAD_STARTED: {
    "Video ID": string
    Duration: string
    Size: string
  }
  UPLOAD_CANCELLED: { "Video ID": string }
  UPLOAD_FAILED: { "Video ID": string; "Error Message": string }
  UPLOAD_SUCCEEDED: { "Asset ID": string; "Video ID": string }
}
